<template>
  <v-row no-gutters>
    <v-col
      cols="6"
      offset="2"
      offset-md="0"
      md="4"
      class="align-self-center"
    >
      <img
        alt="no-comparaison"
        class="mt-6 align-self-center"
        src="@/assets/no-comparaison.svg"
      >
    </v-col>
    <v-col
      cols="12"
      offset-md="1"
      md="7"
      class="align-self-center"
    >
      <v-chip
        color="#EC6608"
        label
      >
        <div class="texte white--text">
          Non renseigné
        </div>
      </v-chip>
      <div class="intro texte-gris-fonce mt-4">
        {{ texte }}
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'InfoManquanteContentModal',
  props: {
    texte: {
      type: String,
      default: 'Complétez vos paramètres d\'exploitation pour accéder aux outils d\'analyse.'
    }
  }
}
</script>

